/* eslint-disable @typescript-eslint/camelcase */
import { DateTime } from 'luxon';
import userState from '@/store/user';
import { FieldChildrenProp } from '@/services/hexabase/types';

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalForm {
  // 新規登録用オプション情報
  export const REGISTER_OPTIONS = [
    // 公開開始日
    {
      display_id: 'publication_start_date',
      props: {
        format: 'yyyy/MM/dd',
        isClearable: true
      }
    },
    // 公開終了日
    {
      display_id: 'publication_end_date',
      props: {
        format: 'yyyy/MM/dd',
        isClearable: true
      }
    }
  ];
  // 更新用オプション情報
  export const EDIT_OPTIONS = [
    // 公開開始日
    {
      display_id: 'publication_start_date',
      props: {
        format: 'yyyy/MM/dd',
        isClearable: true
      }
    },
    // 公開終了日
    {
      display_id: 'publication_end_date',
      props: {
        format: 'yyyy/MM/dd',
        isClearable: true
      }
    }
  ];
}
export const informationRegisterOptionalForm = optionalForm.REGISTER_OPTIONS;
export const informationEditOptionalForm = optionalForm.EDIT_OPTIONS;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace searchForm {
  // マスタメンテナンス お知らせ情報検索用検索フォーム情報
  export const MAINTENANCE = [
    {
      display_id: 'information_title',
      col: 0,
      row: 2,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      display_id: 'information_contents',
      col: 3,
      row: 2,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      display_id: 'information_contents_m',
      col: 0,
      row: 3,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'dataType': 'datetime',
      component: 'DatePickerRangeArea',
      display_id: 'publication_start_date',
      props: {
        format: 'yyyy/MM/dd',
        nameFrom: 'publication_start_date',
        nameTo: 'publication_start_date',
        valueFrom: '',
        valueTo: '',
        isClearable: true
      },
      col: 0,
      row: 5,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'dataType': 'datetime',
      component: 'DatePickerRangeArea',
      display_id: 'publication_end_date',
      props: {
        format: 'yyyy/MM/dd',
        nameFrom: 'publication_end_date',
        nameTo: 'publication_end_date',
        valueFrom: '',
        valueTo: '',
        isClearable: true
      },
      col: 3,
      row: 5,
      sizeX: 3,
      sizeY: 1,
      show: true
    },
    {
      'dataType': 'datetime',
      component: 'DatePickerRangeArea',
      display_id: 'registration_date',
      props: {
        format: 'yyyy/MM/dd',
        nameFrom: 'registration_date',
        nameTo: 'registration_date',
        valueFrom: '',
        valueTo: '',
        isClearable: true
      },
      col: 3,
      row: 6,
      sizeX: 3,
      sizeY: 1,
      show: true
    }
  ];
}
export const searchFormInformationList = searchForm.MAINTENANCE;
